import React from "react";
import RedemptionsBar from "@components/RedemptionDetails/RedemptionsBar";

const RedemptionsSelectedValue = ({ props, ticketClass }) => {
    const { data, selectProps } = props;  

    return (
        <div
            role="button"
            tabIndex={0}
            className="custom-single-value"
            onMouseDown={(e) => {
                e.stopPropagation();
                selectProps.handleMenuDropdown();
            }}
        >
            <RedemptionsBar
                promoDetails={data}
                ticketClass={ticketClass}
            />
        </div>
    );
};

export default RedemptionsSelectedValue;
